import { observer } from "mobx-react-lite";
import { TierlistView } from "../view/tierlistView";

const Tierlist = observer(
    function TierlistRender(props) {
        function updateRatingACB(movie, newRating) {
            props.movieModel.changeRating(movie.imdbid, newRating);
        }
        return (
            <TierlistView
                ratings={props.movieModel.ratings}
                updateRatingACB={updateRatingACB}
            />
        );
    }
);

export { Tierlist };